import { Z_INDEX_MAP } from '../constants';
export const zIndexValue = (module = 'base', number = 0) => (Z_INDEX_MAP[module] || 0) + number;